module.exports = __webpack_public_path__ + "static/img/14000262.cba0c390.png";